<template>
    <div class="progress-bar">
        <div class="progress-bar__progress">
            <div
                class="columns progress-bar__header align-right"
                data-test="progress-bar-header"
            >
                <div>
                    <h5>{{ title }}</h5>
                    <p
                        v-if="name"
                        class="show-for-large"
                    >
                        {{ name }}
                    </p>
                </div>
            </div>
            <div
                v-for="(pill, pillIndex) in pills"
                id="additional-information"
                :key="pillIndex"

                :class="limit(pillIndex)"
                :data-test="'progress-bar-step-'+pillIndex"
            >
                <div class="bg" />
                <div class="progress-bar__content">
                    <div class="columns shrink number">
                        {{ pillIndex + 1 }}
                    </div>
                    <div class="columns shrink check">
                        <i class="icon icon-check" />
                    </div>
                    <div
                        class="columns show-for-large"
                        v-html="pill.title"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        name: {
            type: String,
            default: ''
        },
        pills: {
            type: Array,
            default() {
                return [];
            }
        },
        title: {
            type: String,
            default() {
                return 'Anmeld Skade';
            }
        },
        baseZeroIndex: {
            type: Boolean,
            default() {
                return false;
            }
        },
        // index: {
        //     type: Number,
        //     default: 0
        // },
        flowIndex: {
            type: Number,
            default: 0
        }
        // currentTemplate: {
        //     type: String,
        //     default: ''
        // }
    },
    data() {
        return {
            counter: 1
        };
    },
    methods: {
        limit(pillIndex) {
            if (!this.baseZeroIndex) {
                return ['columns',
                    {
                        active: (pillIndex + 1) === this.flowIndex,
                        done: (pillIndex + 1) < this.flowIndex
                    }];
            } {
                return ['columns',
                    {
                        active: pillIndex === this.flowIndex,
                        done: (pillIndex) < this.flowIndex
                    }];
            }
        }
    }
};
</script>
